import React from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Navbar.css';
import logobalk from '../assets/logobalk.png';

const Navbar = () => {
    return (
        <nav className="navbar navbar-expand-lg navbar-dark fixed-top">
            <div className="container-fluid">
                <Link to="/dashboard" className="navbar-brand logo-wrapper" aria-label="Homepage">
                    <img src={logobalk} alt="HorecaMasters Logo" className="img-fluid logo-image" />
                </Link>
            </div>
        </nav>
    );
};

export default Navbar;
